<script>
export default {
    name: 'placeholder',
    data: function() {
        return {
            placeholder: '_______',
            placeholderImg: 'https://via.placeholder.com/150',
        };
    },
}
</script>